import type { ReactNode } from "react";
import { useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";

import actions from "@/actions";
import { markerTypeLabels } from "@/constants/marker-constants";

interface TopBarAddModeProps {
    arrayOfLights: {
        lights: number;
        direction: string;
        spacing: number;
    };
    lightTypeName: string;
    isMarker: boolean;
    persistModeLights: () => void;
    changeMode: (name: string) => void;
    setInformation: (message: string) => void;
}

const TopBarAddMode = ({
    arrayOfLights,
    lightTypeName,
    isMarker,
    persistModeLights,
    changeMode,
    setInformation,
}: TopBarAddModeProps): ReactNode => {
    const prevLightsCountRef = useRef(Number(arrayOfLights.lights));

    const handleCancel = useCallback(() => {
        changeMode("view");
    }, [changeMode]);

    useEffect(() => {
        const currentLightsCount = Number(arrayOfLights.lights);
        const prevLightsCount = prevLightsCountRef.current;

        if (prevLightsCount !== currentLightsCount) {
            if (currentLightsCount > 1 && prevLightsCount === 1) {
                setInformation("Tap to place the start point for the array.");
            } else if (prevLightsCount > 1 && currentLightsCount === 1) {
                setInformation("Tap to place the light.");
            }
        }

        prevLightsCountRef.current = currentLightsCount;
    }, [arrayOfLights.lights, setInformation]);

    return (
        <div className="topBar">
            <div className="row">
                <div className="col-sm">
                    <p className="textTopbar">
                        Add {lightTypeName}
                        {!isMarker && " Lights"}
                    </p>
                </div>
                <div className="col-sm">
                    <div className="link" onClick={handleCancel}>
                        Cancel Adding
                    </div>
                </div>
                <div
                    className="col-sm d-flex align-items-center justify-content-end me-2"
                    onClick={persistModeLights}
                >
                    <button type="button" className="btn btn-dark done">
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ map }: { map: any }) => {
    const { props } = map.general.mode;
    const isMarker = !!props.markerType;

    return {
        arrayOfLights: map.general.arrayOfLights,
        lightTypeName: isMarker
            ? (markerTypeLabels[props.markerType] ?? props.markerType)
            : props.lightType.displayName,
        isMarker,
    };
};
const mapDispatchToProps = {
    configureArrayOfLights: actions.map.general.configureArrayOfLights,
    clearArrayOfLights: actions.map.general.clearArrayOfLights,
    persistModeLights: actions.map.general.persistModeLights,
    changeMode: actions.map.general.changeMode,
    setInformation: actions.window.setInformation,
};
export default connect(mapStateToProps, mapDispatchToProps)(TopBarAddMode);
